/* Banner dei cookie Aventurx (snippets/axr-consent.liquid, Impostazioni tema → Aventurx — Cookie e privacy).
   Le scelte stanno nel cookie tecnico "axr_consent" (versione, data, categorie) per i giorni impostati; window.axrCk
   (snippets/axr-consent-head.liquid) le rende disponibili al resto del sito. A ogni scelta:
   - Google Consent Mode v2 viene aggiornato e partono gli script in attesa (Google Ads, Tag Manager);
   - Shopify riceve le stesse scelte con la Customer Privacy API (statistiche, marketing, preferenze);
   - parte l'evento "axr:consent" sul documento (per esempio le mappe dei negozi si caricano da sole);
   - se una categoria viene tolta, i suoi cookie di questo dominio vengono cancellati e la pagina si ricarica,
     così gli script già partiti si fermano. */
(function () {
  'use strict';
  var ck = window.axrCk;
  var root = document.querySelector('[data-axr-ck]');
  var prefs = document.querySelector('[data-axr-ck-prefs]');
  if (!ck || !root || !prefs) return;

  var CATS = ['functional', 'statistics', 'marketing'];
  // cookie di questo dominio che appartengono a ogni categoria (quelli di terze parti li gestisce il loro dominio)
  var CLEAN = {
    statistics: [/^_ga($|_)/, /^_gid$/, /^_gat/, /^_shopify_(y|s|sa_t|sa_p)$/, /^_clck$/, /^_clsk$/],
    marketing: [/^_gcl_/, /^_fbp$/, /^_fbc$/, /^_ttp$/, /^_tt_enable_cookie$/, /^__kla_id$/, /^_pin_unauth$/, /^_uetsid$/, /^_uetvid$/]
  };
  var html = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var opener = null;

  function copy(c) { return { functional: !!c.functional, statistics: !!c.statistics, marketing: !!c.marketing }; }
  function all(on) { return { functional: on, statistics: on, marketing: on }; }
  function randomId() {
    try { return Array.prototype.map.call(crypto.getRandomValues(new Uint8Array(8)), function (b) { return ('0' + b.toString(16)).slice(-2); }).join(''); }
    catch (e) { return String(Date.now()) + Math.random().toString(16).slice(2, 8); }
  }

  function writeRecord(c) {
    var rec = { v: ck.cfg.v, t: Date.now(), id: (ck.record && ck.record.id) || randomId(), c: copy(c) };
    var cookie = 'axr_consent=' + encodeURIComponent(JSON.stringify(rec)) + '; path=/; max-age=' + Math.round(ck.cfg.days * 86400) + '; SameSite=Lax';
    if (location.protocol === 'https:') cookie += '; Secure';
    document.cookie = cookie;
    ck.record = rec;
    return rec;
  }

  function cleanCookies(cats) {
    var names = document.cookie.split(';').map(function (p) { return p.split('=')[0].trim(); });
    var host = location.hostname.split('.');
    var domains = [''];
    for (var i = 0; i < host.length - 1; i++) domains.push('; domain=.' + host.slice(i).join('.'));
    names.forEach(function (name) {
      var hit = cats.some(function (cat) { return (CLEAN[cat] || []).some(function (re) { return re.test(name); }); });
      if (!hit) return;
      domains.forEach(function (d) { document.cookie = name + '=; path=/; max-age=0' + d; });
    });
  }

  // Shopify (statistiche e pixel delle app): stesse scelte con la Customer Privacy API
  function toShopify(c, onlyIfDifferent) {
    var send = function () {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.setTrackingConsent !== 'function') return;
      var want = { analytics: c.statistics, marketing: c.marketing, preferences: c.functional, sale_of_data: c.marketing };
      if (onlyIfDifferent && typeof cp.currentVisitorConsent === 'function') {
        try {
          var now = cp.currentVisitorConsent() || {};
          var yes = function (v) { return v === 'yes' || v === true; };
          if (yes(now.analytics) === want.analytics && yes(now.marketing) === want.marketing && yes(now.preferences) === want.preferences) return;
        } catch (e) { /* si invia comunque */ }
      }
      try { cp.setTrackingConsent(want, function () {}); } catch (e) { /* Shopify non disponibile */ }
    };
    if (window.Shopify && window.Shopify.customerPrivacy) { send(); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) send(); });
    }
  }

  function toGoogle(c) {
    if (typeof window.gtag !== 'function') return;
    var st = function (on) { return on ? 'granted' : 'denied'; };
    window.gtag('consent', 'update', {
      ad_storage: st(c.marketing),
      ad_user_data: st(c.marketing),
      ad_personalization: st(c.marketing),
      analytics_storage: st(c.statistics),
      personalization_storage: st(c.functional)
    });
    window.gtag('set', 'ads_data_redaction', !c.marketing);
    (window.dataLayer = window.dataLayer || []).push({ event: 'axr_consent_update', axr_consent: copy(c) });
  }

  function apply(c, fromUser) {
    var before = ck.decided ? copy(ck.state) : all(false);
    var wasDecided = ck.decided;
    c = copy(c);
    writeRecord(c);
    ck.state = c;
    ck.decided = true;
    toGoogle(c);
    toShopify(c, false);
    ck._flush();
    try { document.dispatchEvent(new CustomEvent('axr:consent', { detail: copy(c) })); } catch (e) { /* browser vecchio */ }
    var removed = CATS.filter(function (k) { return before[k] && !c[k]; });
    if (removed.length) cleanCookies(removed);
    hideBanner();
    if (fromUser) toast();
    // una categoria tolta dopo averla data: si ricarica, così gli script già partiti si fermano
    if (wasDecided && removed.length && (removed.indexOf('statistics') > -1 || removed.indexOf('marketing') > -1)) {
      setTimeout(function () { location.reload(); }, 600);
    }
  }

  function showBanner() {
    root.hidden = false;
    html.classList.add('axr-ck-visible');
    requestAnimationFrame(function () { root.classList.add('is-in'); });
  }
  function hideBanner() {
    if (root.hidden) return;
    root.classList.remove('is-in');
    html.classList.remove('axr-ck-visible');
    setTimeout(function () { root.hidden = true; }, reduceMotion.matches ? 0 : 220);
  }

  function toast() {
    var t = document.querySelector('[data-axr-ck-toast]');
    if (!t) return;
    t.hidden = false;
    clearTimeout(t._axrT);
    t._axrT = setTimeout(function () { t.hidden = true; }, 2600);
  }

  // ---- pannello delle preferenze ----
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
  function focusables() {
    return Array.prototype.filter.call(prefs.querySelectorAll(FOCUSABLE), function (el) { return el.offsetParent !== null; });
  }
  function openPrefs(trigger) {
    opener = trigger || document.activeElement;
    prefs.querySelectorAll('[data-axr-ck-cat]').forEach(function (input) {
      input.checked = !!ck.state[input.getAttribute('data-axr-ck-cat')];
    });
    prefs.hidden = false;
    html.classList.add('axr-ckp-open');
    requestAnimationFrame(function () { prefs.classList.add('is-in'); });
    var box = prefs.querySelector('.axr-ckp__box');
    if (box) box.focus({ preventScroll: true });
  }
  function closePrefs() {
    if (prefs.hidden) return;
    prefs.classList.remove('is-in');
    html.classList.remove('axr-ckp-open');
    setTimeout(function () { prefs.hidden = true; }, reduceMotion.matches ? 0 : 200);
    if (opener && typeof opener.focus === 'function' && document.contains(opener)) opener.focus({ preventScroll: true });
    opener = null;
  }
  function readPrefs() {
    var c = copy(ck.state);
    prefs.querySelectorAll('[data-axr-ck-cat]').forEach(function (input) { c[input.getAttribute('data-axr-ck-cat')] = input.checked; });
    return c;
  }

  document.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!(t instanceof Element)) return;
    if (t.closest('[data-axr-ck-accept]')) { apply(all(true), true); closePrefs(); return; }
    if (t.closest('[data-axr-ck-reject]')) { apply(all(false), true); closePrefs(); return; }
    if (t.closest('[data-axr-ck-close]')) { apply(ck.decided ? ck.state : all(false), false); return; }
    if (t.closest('[data-axr-ck-save]')) { apply(readPrefs(), true); closePrefs(); return; }
    if (t.closest('[data-axr-ck-prefs-close]')) { closePrefs(); return; }
    var allow = t.closest('[data-axr-ck-allow]');
    if (allow) {
      evt.preventDefault();
      var c = copy(ck.state);
      c[allow.getAttribute('data-axr-ck-allow')] = true;
      apply(c, true);
      return;
    }
    var open = t.closest('[data-axr-ck-open], a[href="#cookie-preferenze"], a[href$="#cookie-preferenze"]');
    if (open) { evt.preventDefault(); openPrefs(open); }
  });

  document.addEventListener('keydown', function (evt) {
    if (prefs.hidden) return;
    if (evt.key === 'Escape') { evt.preventDefault(); closePrefs(); return; }
    if (evt.key !== 'Tab') return;
    var list = focusables();
    var box = prefs.querySelector('.axr-ckp__box');
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (evt.shiftKey && (document.activeElement === first || document.activeElement === box)) { evt.preventDefault(); last.focus(); }
    else if (!evt.shiftKey && document.activeElement === last) { evt.preventDefault(); first.focus(); }
  });

  window.axrCk.open = function () { openPrefs(null); };
  window.axrCk.set = function (c) { apply(c, true); };

  if (ck.decided) {
    // le scelte ci sono: Shopify allineato (per esempio se il suo cookie è scaduto prima del nostro)
    toShopify(ck.state, true);
  } else {
    showBanner();
  }
  if (/[?&]cookie-preferenze\b/.test(location.search) || location.hash === '#cookie-preferenze') openPrefs(null);
})();
